jQuery(function($) {
	var windowWidth = window.innerWidth;
	var $body = $('body');
	var $window = $(window);

	/*--------------------------------------------------------------
	# Fix for Accordions parents links
	--------------------------------------------------------------*/
	var	toggle = '[data-toggle]';

	var acA = $('[data-accordion-link]');
	acA.on('click', function () {
		if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$(toggle).removeClass('open');
				$(toggle).next('.inner').removeClass('show').css('display', 'none');
				target.next('.inner').addClass('show').slideDown(350);
				target.addClass('open');
				target.next('.inner').addClass('show').slideDown(350);
				return false;
			}
		}
	});


	/*--------------------------------------------------------------
	# Hamburger Menu
	--------------------------------------------------------------*/
	var menuBtn = '[data-menu-btn]';
	var mainNav = '[data-main-nav]';
	var parentLink = $(mainNav).find('.menu-item-has-children');

	$(menuBtn).on('click', function () {
		$(this).toggleClass('open');
		$(mainNav).slideToggle('normal');
		// $body.toggleClass('overlay');
		parentLink.find('.sub-menu').slideUp();
	});

	parentLink.on('click', function () {
		$(this).find('.sub-menu').slideToggle();
	});


	/*--------------------------------------------------------------
	# Sticky Menu
	--------------------------------------------------------------*/
	if (windowWidth > 820) {
		var headerB = '[data-header-bottom]';
		var siteMain = '[data-main]';
		var stickyTop = $(headerB).offset().top;
		$(window).on('scroll', function () {
			if ($(window).scrollTop() >= stickyTop) {
				$(siteMain).addClass('sticky-content');
				$(headerB).addClass('sticky-menu');
			} else {
				$(siteMain).removeClass('sticky-content');
				$(headerB).removeClass('sticky-menu');
			}
		});
	}


	/*--------------------------------------------------------------
	# Slick Slider
	--------------------------------------------------------------*/
	var slider = '[data-slider]';
	$(slider).slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 1000,
		arrows: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	var sliderHalf = '[data-half-slider]';
	$(sliderHalf).slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1500,
		arrows: false
	});

	//halfslide fix (show after everithing is loaded)
	$(sliderHalf).css({
		opacity: '1',
		visibility: 'visible'
	});

	var sliderTestimonials = '[data-testimonials]';
	var arrowP = '[data-testimonials-arrow-prev]'; 
	var arrowN = '[data-testimonials-arrow-next]';
	$(sliderTestimonials).slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: true,
		prevArrow: $(arrowP),
		nextArrow: $(arrowN)
	});

	// video slider fix (wrap every five videos to one slide)
	var divsSlide = '[data-video-slide]';
	for (var i = 0; i < $(divsSlide).length; i += 5) {
		$(divsSlide).slice(i, i + 5).wrapAll('<div class="slide-wrap"></div>');
	}

	var sliderVideos = '[data-video-slider]';
	$(sliderVideos).slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1500,
		arrows: false
	});

	// video slider fix (wrap every five videos to one slide)
	var divBox = '[data-news]';
	if (windowWidth > 991) {
		for (var i = 0; i < $(divBox).length; i += 20) {
			$(divBox).slice(i, i + 20).wrapAll('<div class="slide"></div>');
		}
	} else {
		for (var i = 0; i < $(divBox).length; i += 10) {
			$(divBox).slice(i, i + 10).wrapAll('<div class="slide"></div>');
		}
	}

	var sliderNews = '[data-news-slider]';
	$(sliderNews).slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1500,
		arrows: false
	});


	/*--------------------------------------------------------------
	# Header Search
	--------------------------------------------------------------*/
	var searchBtn = '[data-search-btn]';

	$(searchBtn).on('click', function () {
		$('.links .search-form').toggleClass('active');
		$('.links .search-btn').toggleClass('active');
	});


	/*--------------------------------------------------------------
	# Newsletter Popup
	--------------------------------------------------------------*/
	var subscribe = '[data-subscribe]';
	var popW = '[data-popup-wrapper]';
	var pop = '[data-popup]';
	var popX = '[data-popup-close]';
	$(subscribe).on('click', function () {
		$(pop).addClass('open');
		$(popW).addClass('open');
		$body.addClass('popup-body');
	});

	var container = $(pop);
	$(document).mouseup(function (e) {
		var container = $(pop);
		var popup = $(popW);
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			popup.find(pop).removeClass('open');
			$(popW).removeClass('open');
			$body.removeClass('popup-body');
		}
	});

	$(popX).on('click', function () {
		$(pop).removeClass('open');
		$(popW).removeClass('open');
		$body.removeClass('popup-body');
	});


	/*--------------------------------------------------------------
	## SMOOT SCROLLING
	--------------------------------------------------------------*/
	$('a[href*=#]:not([href=#])').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - 150
				}, 1700);
				return false;
			}
		}
	});


	/*--------------------------------------------------------------
	# Parallax Background
	--------------------------------------------------------------*/
	var parX = '[data-parallax]';
	if (windowWidth > 992) {
		function parallax(selector, speed) {
			if (selector.length !== 0) {
				var sectionOffset = selector.offset().top;
				var scrolled = $(window).scrollTop() - sectionOffset;
				var sectionPosition = '50% ' + ((scrolled * speed)) + 'px';
				selector.css('background-position', sectionPosition);
			}
		}

		parallax($(parX), 0.2);
		$(window).on('scroll', function () {
			parallax($(parX), 0.2);
		});
	}


	/*--------------------------------------------------------------
	# Accordions
	--------------------------------------------------------------*/
	// "var toggle" is defined on top of this document
	$(toggle).click(function (e) {
		e.preventDefault();

		var $this = $(this);

		if ($this.next().hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
			$this.removeClass('open');
		} else {
			$this.parent().parent().find('li .inner').removeClass('show');
			$this.parent().parent().find('.toggle').removeClass('open');
			$this.parent().parent().find('li .inner').slideUp(350);
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
			$this.toggleClass('open');
		}
	});


	/*--------------------------------------------------------------
	# Fancy Box Video
	--------------------------------------------------------------*/
	$('[data-fancybox]').fancybox({
		youtube: {
			controls: 1,
			showinfo: 0,
		}
	});

	/*--------------------------------------------------------------
	# Escape Button
	--------------------------------------------------------------*/
	$('[data-escape]').on('click', function(e) {
		e.preventDefault();
		$body.empty();
		var currentTab = $(this).attr('href');
		var newTab = $(this).attr('data-escape');

		window.open(currentTab, '_self', '');
		window.open(newTab, '_blank', '');
		window.close();
	});

});
